import React, { useEffect, useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { TbChevronLeftPipe, TbGalaxy, TbNetwork, TbRocket, TbSandbox, TbTerminal } from "react-icons/tb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MdOutlineAdminPanelSettings, MdOutlineBackup, MdOutlineOpenInNew } from "react-icons/md";
import { PiDatabaseLight, PiNoteBlankLight, PiVectorThreeFill } from "react-icons/pi";
import { RiCheckboxMultipleBlankLine, RiKey2Line, RiNodeTree } from "react-icons/ri";
import { BiCloud, BiFileBlank, BiLock, BiPlug, BiServer, BiUser, BiWorld } from "react-icons/bi";
import Spinner from "../../Components/Spinner";
import { HiLogout } from "react-icons/hi";
import { BsGear, BsPeople } from "react-icons/bs";
import DeleteRecordModal from "../ViewComponents/DeleteRecordModal";
import { Dropdown } from "react-bootstrap";
import { VscBlank } from "react-icons/vsc";
import { GrNode, GrNodes } from "react-icons/gr";

function ProjectSidebar({ onNavigate, userData, statusRefresh, isSidebarClosed, setIsSidebarClosed }) {
    const { t } = useLanguage();
    const { project_id } = useParams()
    const navigate = useNavigate()
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('');
    const [expandedSection, setExpandedSection] = useState('data');
    const [activeChatId, setActiveChatId] = useState(null);

    const [loadingChats, setLoadingChats] = useState(false);
    const [sizeCloud, setSizeCloud] = useState("")
    const [projectName, setProjectName] = useState("")
    const [loading, setLoading] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [netName, setNetName] = useState("")

    const HandleNavigate = (path) => {
        navigate(`/project_panel/${project_id}/cloud_storage/${path}`)
    }

    useEffect(() => {
        const links = ['profile', 'projects', 'billing', 'support', 'cloud_storage', 'deleted_files', 'access', 'api', 'databases', 'backup', "network", 'settings', 'clusters', "playbox", "deployments", "hosting"];
        const matched = links.find(link => location.pathname.includes(link));
        if (matched) {
            setActiveLink(matched);
        }
    }, [location.pathname]);



    const handleLinkClick = (link) => {
        setActiveLink(link);
        onNavigate(link);
    };

    const getLinkStyle = (link) => {
        return activeLink === link ? ({ color: "var(--mainColor)" }) : {};
    };

    const getSublinkStyle = (linkOrId) => {
        if (activeLink === linkOrId) {
            return { color: "var(--textColor)", borderRight: "2px solid var(--secondColor)" };
        }
        return {};
    };


    const handleLogout = () => {
        setLoading(true);
        sessionStorage.removeItem("user_id");
        document.cookie = "erioon=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        setTimeout(() => {
            navigate(`/login`);
        }, 700);
    };

    const toggleSection = (section) => {
        if (expandedSection === section) {
            setExpandedSection(null);
        } else {
            setExpandedSection(section);
        }
    };

    const isSectionOpen = (section) => expandedSection === section;


    const handleDeleteClick = (chat_id, chat_name) => {
        setSelectedRecordId(chat_id);
        setNetName(chat_name)
        setShowDeleteModal(true);
    };


    return (
        <div className={`sidebar_cont_proj fade-in ${isSidebarClosed ? "closed_sidebar_proj" : ""}`}>
            {isSidebarClosed ? (
                <>
                    <div className="sidebar_body">
                        <div className="sidebar_body_main">
                            <div className="open_project_sidebar_body">
                                {/* <div className="link_container">
                                    <p className="side_link" onClick={() => navigate(`/${project_id}/codespace`)} style={getLinkStyle('codespaces')}>
                                        <i><TbTerminal /></i>
                                    </p>
                                </div> */}

                                <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('databases')} style={getLinkStyle('databases')}>
                                        <i><PiDatabaseLight /></i>
                                    </p>
                                </div>

                                <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('backup')} style={getLinkStyle('backup')}>
                                        <i><MdOutlineBackup /></i>
                                    </p>
                                </div>

                                <div className="divisor_sidebar"></div>

                                <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('access')} style={getLinkStyle('access')}>
                                        <i><MdOutlineAdminPanelSettings /></i>
                                    </p>
                                </div>
                                <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('network')} style={getLinkStyle('network')}>
                                        <i><TbNetwork /></i>
                                    </p>
                                </div>

                            </div>
                        </div> <div className="link_container">
                            <p className="side_link" onClick={() => window.open(`/dev-docs/introduction`, '_blank')}  style={getLinkStyle('settings')}>
                                <i><PiNoteBlankLight /></i>
                            </p>
                        </div>
                        <div className="link_container">
                            <p className="side_link" onClick={() => onNavigate('settings')} style={getLinkStyle('settings')}>
                                <i><BsGear /></i>
                            </p>
                        </div>
                        <div className="link_container">
                            <p className="side_link" onClick={() => onNavigate('profile')} style={getLinkStyle('profile')}>
                                <i><BiUser /></i>
                            </p>
                        </div>

                        <div className="link_container">
                            <p className="side_link logout_side_link" onClick={handleLogout} style={getLinkStyle('logout')}>
                                {loading ? (
                                    <div className="side_link_spinner_cont">
                                        <Spinner loading={true} err={({ message: "", display: "none" })} />
                                    </div>
                                ) : (
                                    <i><HiLogout /></i>
                                )}
                            </p>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="sidebar_body">
                        <div className="sidebar_body_main">
                            <div className="open_project_sidebar_body">
                                {/* <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('dashboard')} style={getLinkStyle('dashboard')}>
                                        <i><VscGraphLine /></i> {t.sidebar.dashboard}
                                    </p>
                                </div> */}

                                {/* <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('erioon-ai')} style={getLinkStyle('erioon-ai')}>
                                        <i><TbGalaxy /></i> ErioonAI
                                    </p>
                                </div> */}

                                {/* <div className="link_container">
                                    <p className="side_link" onClick={() => handleLinkClick('clusters')} style={getLinkStyle('clusters')}>
                                        <i><BiLayerPlus /></i> {t.sidebar.clusters}
                                    </p>
                                </div> */}
                                {/* <span className="locked_section_link"><HiLockClosed /></span> */}
                                {/* <div className="link_container_divisor">
                                    <p className="side_link_divisor">
                                        Developement
                                    </p>
                                </div> */}
                                {/* <div className="link_container">
                                    <p
                                        className="side_link"

                                        // onClick={() => handleLinkClick('codespaces')}
                                        style={getLinkStyle('codespaces')}
                                    >
                                        <span className="side_link_span" onClick={() => navigate(`/${project_id}/codespace`)}><i><TbTerminal /></i> Codespace</span> <span className="coming_soon_span" onClick={() => window.open(`/${project_id}/codespace`, '_blank')}><MdOutlineOpenInNew /></span>
                                    </p>
                                </div> */}

                                {/* <div className="link_container_divisor">
                                    <p className="side_link_divisor">
                                        Data
                                    </p>
                                </div> */}
                                <div className="side_link" onClick={() => toggleSection('data')} style={getLinkStyle('data')}>
                                    <div className="main_side_link_cont">
                                        <i><PiDatabaseLight /></i> Data
                                    </div>
                                    <i className={`fa-solid ${isSectionOpen('data') ? "fa-chevron-up" : "fa-chevron-down"} chevron_side_link`} ></i>
                                </div>
                                <div className={`link_container_anim ${isSectionOpen("data") ? "link_container_expanded" : ""}`}>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('databases')} style={getSublinkStyle('databases')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>Databases</p>
                                    </div>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('backup')} style={getSublinkStyle('backup')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>Backup</p>
                                    </div>
                                </div>

                                {/* <div className="side_link" onClick={() => toggleSection('llm')} style={getLinkStyle('llm')}>
                                    <div className="main_side_link_cont">
                                        <i><GrNodes /></i> LLMs
                                    </div>
                                    <i className={`fa-solid ${isSectionOpen('llm') ? "fa-chevron-up" : "fa-chevron-down"} chevron_side_link`} ></i>
                                </div>
                                <div className={`link_container_anim ${isSectionOpen("llm") ? "link_container_expanded" : ""}`}>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('new_mcp')} style={getSublinkStyle('new_mcp')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>Catalog</p>
                                    </div>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('mcps')} style={getSublinkStyle('mcps')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>Available LLM</p>
                                    </div>
                                </div>

                                <div className="side_link" onClick={() => toggleSection('mcp')} style={getLinkStyle('mcp')}>
                                    <div className="main_side_link_cont">
                                        <i><BiServer /></i> MCP
                                    </div>
                                    <i className={`fa-solid ${isSectionOpen('mcp') ? "fa-chevron-up" : "fa-chevron-down"} chevron_side_link`} ></i>
                                </div>
                                <div className={`link_container_anim ${isSectionOpen("mcp") ? "link_container_expanded" : ""}`}>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('new_mcp')} style={getSublinkStyle('new_mcp')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>New MCP server</p>
                                    </div>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('mcps')} style={getSublinkStyle('mcps')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>MCPs</p>
                                    </div>
                                </div> */}
                                {/* <div className="side_link" onClick={() => toggleSection('storage')} style={getLinkStyle('storage')}>
                                    <div className="main_side_link_cont">
                                        <i><BiCloud /></i> Storage
                                    </div>
                                    <i className={`fa-solid ${isSectionOpen('storage') ? "fa-chevron-up" : "fa-chevron-down"} chevron_side_link`} ></i>
                                </div>
                                <div className={`link_container_anim ${isSectionOpen("storage") ? "link_container_expanded" : ""}`}>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('cloud_storage')} style={getSublinkStyle('cloud_storage')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>Files</p>
                                    </div>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('deleted_files')} style={getSublinkStyle('deleted_files')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>{t.sidebar.deleted_files}</p>
                                    </div>

                                </div> */}

                                {/* <div className="link_container_divisor">
                                    <p className="side_link_divisor">
                                        Security
                                    </p>
                                </div> */}
                                {/* <div className="side_link" onClick={() => toggleSection('security')} style={getLinkStyle('security')}>
                                    <div className="main_side_link_cont">
                                        <i><MdOutlineAdminPanelSettings /></i> Security
                                    </div>
                                    <i className={`fa-solid ${isSectionOpen('security') ? "fa-chevron-up" : "fa-chevron-down"} chevron_side_link`} ></i>
                                </div>
                                <div className={`link_container_anim ${isSectionOpen("security") ? "link_container_expanded" : ""}`}>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('access')} style={getSublinkStyle('access')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p >{t.sidebar.access}</p>
                                    </div>
                                    <div className="side_link_opened" onClick={() => handleLinkClick('network')} style={getSublinkStyle('network')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p >Network</p>
                                    </div>

                                </div> */}

                                <div className="link_container">
                                    <p
                                        className="side_link"
                                        onClick={() => handleLinkClick('access')}
                                        style={getLinkStyle('access')}
                                    >
                                        <span className="side_link_span" ><i><MdOutlineAdminPanelSettings /></i> Access</span>
                                    </p>
                                </div>
                                 <div className="link_container">
                                    <p
                                        className="side_link"
                                        onClick={() => handleLinkClick('network')}
                                        style={getLinkStyle('network')}
                                    >
                                        <span className="side_link_span" ><i><TbNetwork /></i> Network</span>
                                    </p>
                                </div>


                            </div>

                            {/* <div className="sidebar_body_second">
                                <div className="side_link side_link_cloud" onClick={() => handleLinkClick('cloud_storage')} style={getLinkStyle('cloud_storage')}>
                                    <div className="main_side_link_cont">
                                        <i><IoIosCloudOutline /></i> {t.sidebar.cloud_storage}
                                    </div>
                                </div>
                                <div className="available_storage_cont">
                                    <div className="available_storage_bar">
                                        <div
                                            className="inner_available_storage_bar"
                                            style={{
                                                width: `${(sizeCloud / 1024 / 1024 / 100) * 100}%`,
                                                backgroundColor: (sizeCloud / 1024 / 1024) > 99 ? "red" : "green",
                                                transition: "width 0.5s ease-in-out"
                                            }}
                                        ></div>
                                    </div>
                                    <p className="available_storage_gb">
                                        {(sizeCloud / 1024 / 1024 / 1024).toFixed(2)}/100GB
                                    </p>
                                </div>


                                <div className="link_container_anim link_container_expanded">
                                    <div className="side_link_opened" onClick={() => HandleNavigate('deleted_files')} style={getSublinkStyle('deleted_files')}>
                                        <div className="side_link_bar">
                                            <div className="side_link_bar_top"></div>
                                            <div className="side_link_bar_bottom"></div>
                                        </div>
                                        <p>{t.sidebar.deleted_files}</p>
                                    </div>
                                </div>

                            </div> */}
                        </div>
                    </div>
                    <div className="sidebar_footer">
                        <div className="settings_center">
                            {/* <p className="settings_link" onClick={() => onNavigate('settings')} style={getLinkStyle('settings')}><i><BsGear /></i> {t.sidebar.settings}</p> */}
                            {/* <p className="settings_link" onClick={() => onNavigate('profile')} style={getLinkStyle('profile')}><i><BiUser /></i> {t.sidebar.profile}</p> */}
                          
                            <p className="settings_link" onClick={() => window.open(`/dev-docs/introduction`, '_blank')} style={getLinkStyle('documentation')}><i><PiNoteBlankLight /></i> Developer docs</p>
                            <p className="settings_link" onClick={() => navigate("/control_panel/projects")} style={getLinkStyle('profile')}><i><TbChevronLeftPipe /></i> Control panel</p>


                            {loading ? (
                                <div className="settings_link_info">
                                    <Spinner loading={true} err={({ message: "", display: "none" })} />
                                </div>
                            ) : (
                                userData && (
                                    <div className="settings_link_info" onClick={() => onNavigate('profile')}>
                                        <p className="logout_from_account">{userData.personal_info.name} {userData.personal_info.surname}</p>
                                        <p className="logout_from_account">
                                            {userData.user_type.charAt(0).toUpperCase() + userData.user_type.slice(1)}
                                        </p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                    {/* <div className="open_project_sidebar_cont" onClick={() => navigate("/control_panel/projects")}>
                        <p>
                            <i className="fa-solid fa-chevron-left"></i>
                            {t.sidebar.admin_console}
                        </p>
                    </div> */}
                </>

            )}
        </div>
    );
}

export default ProjectSidebar;
